<!-- ChooseFromProspect.vue -->
<template>

  <EntitySelect
    :current="checkupStore.personEntity"
    :isActive="isActive"
    :placeholder="personEntitySearchPlaceholder"
    @select="addPersonEntity"
  />
</template>


<script>
import EntitySelect from '@frontend/ui/components/utils/EntitySelect.vue';
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';

export default {
  components: { EntitySelect },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { /* Local variables */ };
  },
  computed: {
    ...mapStores(useCheckupStore, useAdvisorStore),
    personEntitySearchPlaceholder() {
      console.log('PERSON ENTITY In Choose Code', this.checkupStore.personEntity);
      return this.checkupStore.personEntity ? this.checkupStore.personEntity.name : 'Select Client For Risk';
    }
  },
  watch: { /*
        Watches an existing property
        Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    async addPersonEntity(personEntity) {
      if (!personEntity?.external_id) return;
      console.log('add personEntity', personEntity);
      this.checkupStore.setPersonEntity(personEntity);
      const response = await fetch(`/api/v1/get-risk-score/${personEntity.external_id}/`);
      const data = await response.json();
      this.checkupStore.setPersonEntity({ ...personEntity, risk_score: data.risk_score });
      console.log('CLIENT RISK', this.checkupStore.clientRisk);
    },

  },
};
</script>


    <style scoped>

    </style>
